import {
  takeEvery,
  select, call,
} from 'redux-saga/effects';

import { analyticsService } from './services/analyticsService';
import { PAGE_TYPE } from '../../services/constants';
import { TRIGGER_ANALYTICS } from '../actions';
import { getAnalyticsData } from '../selectors';

interface AnalyticsData {
  isGeneralAPIFailed: boolean;
  errorMessage: string;
  [key: string]: unknown;
}

export function* analyticsTracking(): Generator {
  const analytics = (yield select(getAnalyticsData)) as AnalyticsData;
  if (analytics.isGeneralAPIFailed) {
    yield call(analyticsService.trackAnalytics, PAGE_TYPE.error, { trackingError: analytics.errorMessage });
  } else {
    yield call(analyticsService.trackAnalytics, PAGE_TYPE.orderSummary, analytics);
  }
}

export function* watchAnalytics(): Generator {
  yield takeEvery(TRIGGER_ANALYTICS, analyticsTracking);
}
